import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useState } from "react";
import ContactUsModal from "./modals/ContactUsModal";
import { useSelector } from "react-redux";
import moment from 'moment';
import { format, toZonedTime } from 'date-fns-tz';
import CustomCountdown from "./CustomCountdown";
import { toast } from "react-toastify";
export var convertToNewYorkTime = function (date) {
    var timeZone = 'America/New_York';
    var zonedDate = toZonedTime(date, timeZone);
    return format(zonedDate, 'yyyy-MM-dd HH:mm:ssXXX', { timeZone: timeZone });
};
var TopBar = function () {
    var _a = useState(false), showContactModal = _a[0], setShowContactModal = _a[1];
    var reset = useSelector(function (state) { return state.statuses.reset; });
    // const timetoReset = moment.tz(reset, "America/New_York").toDate();
    // const timetoReset = moment.unix(reset).format("YYYY-MM-DD HH:mm:ss")
    // var dec = moment(reset);
    // const timetoReset = dec.tz('America/New_York').format('YYYY-MM-DD HH:mm:ss');
    var timetoReset = convertToNewYorkTime(moment.unix(reset).format("YYYY-MM-DD HH:mm:ss"));
    var _b = useState(false), isTimeNegative = _b[0], setIsTimeNegative = _b[1];
    React.useEffect(function () {
        var targetDate = new Date(timetoReset);
        var now = new Date();
        setIsTimeNegative(targetDate < now);
    }, [timetoReset]);
    var handleCountdownComplete = function () {
        window.location.href = "/";
        toast.success("Records have been reset");
    };
    var contactModalHandle = function (value) {
        setShowContactModal(value);
    };
    return (_jsxs("div", { className: "flex h-[33px] justify-between md:justify-center md:gap-5 items-center px-[18px] w-full text-base text-center text-white bg-[#FF5A5A] min-h-[33px]", children: [_jsxs("div", { className: "flex gap-2 items-center self-stretch my-auto ", children: [_jsx("div", { className: "self-stretch text-[16px] my-auto tracking-tight", children: "Records will reset in" }), _jsx("div", { className: "self-stretch text-[16px] my-auto font-semibold tracking-normal", children: !isTimeNegative && _jsx(CustomCountdown, { targetDate: new Date(timetoReset), onComplete: handleCountdownComplete }) })] }), _jsx("button", { onClick: function () { return contactModalHandle(true); }, className: "self-stretch text-sm my-auto font-normal underline cursor-pointer tracking-normal", children: "Contact" }), showContactModal && (_jsx(ContactUsModal, { contactButtonClick: function () { return contactModalHandle(false); }, closeModal: function () { return contactModalHandle(false); } }))] }));
};
export default TopBar;
